import axios from "axios";
import authHeader from "@/Api/AuthHeader";

const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getActiveSemester() {
      return axios.get(URL_API + "activeSemester", { headers: authHeader() });
    },
    async _getActiveSemester(level_id, semester) {
      return await axios.get(
        URL_API +
          `_activeSemesterWithLevel?level=${level_id}&semester=${semester}`,
        {
          headers: authHeader(),
        }
      );
    },
    async getSemesters() {
      try {
        const resp = await axios.get(URL_API + "semesters", {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async addActivities(data) {
      try {
        const resp = await axios.post(URL_API + "activities", data, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },
    async addMotive(motive, id) {
      try {
        const resp = await axios.post(
          URL_API + `motive_activities?id=${id}`,
          { description: motive },
          {
            headers: authHeader(),
          }
        );

        return resp;
      } catch (error) {
        return error;
      }
    },
    async addMotiveFreq(motive, id) {
      try {
        const resp = await axios.post(
          URL_API + `motive_activities_freq?id=${id}`,
          { description: motive },
          {
            headers: authHeader(),
          }
        );

        return resp;
      } catch (error) {
        return error;
      }
    },

    async addMotiveExame(motive, id) {
      try {
        const resp = await axios.post(
          URL_API + `motive_activities_exame?id=${id}`,
          { description: motive },
          {
            headers: authHeader(),
          }
        );

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getAllActivities(data) {
      try {
        const response = await axios.get(
          `${URL_API}activities?page=${data.page}&search=${data.search}&type=${data.type}`,
          { headers: authHeader() }
        );
        return response;
      } catch (error) {
        return error;
      }
    },

    async activeLevels() {
      try {
        const response = await axios.get(`${URL_API}activeLevels`, {
          headers: authHeader(),
        });
        return response;
      } catch (error) {
        return error;
      }
    },
    updateActivitie(formData) {
      return axios.patch(URL_API + `activities/${formData.id}`, formData, {
        headers: authHeader(),
      });
    },
    endSemester(id) {
      return axios.get(URL_API + `endSemester/${id}`, {
        headers: authHeader(),
      });
    },
  },
};
